// ABOUTME: Overview API calls for dashboard metrics
// ABOUTME: Fetches aggregated data from /api/overview endpoint

import { apiClient } from './client'
import type { Overview } from '@/types/analysis'

export const overviewApi = {
  /**
   * Fetch overview metrics from backend
   */
  async getOverview(): Promise<Overview> {
    const response = await apiClient.get<Overview>('/api/overview')
    return response.data
  }
}
